<template>
  <a-card :bordered="false">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="24">
        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
          <a-form-model-item prop="nccTest.url" label="URL（例：/nccloud/api/riaorg/org/dept/queryDeptByCode）">
            <a-input v-model="form.nccTest.url" placeholder="请填写URL" />
          </a-form-model-item>
        </a-col>

        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
          <a-form-model-item prop="nccTest.param" label="参数（例：{code:['WDB11']}）">
            <a-textarea
              @keyup.enter.stop
              placeholder="请填写参数"
              v-model="form.nccTest.param"
              :autoSize="{ minRows: 4 }"
            />
          </a-form-model-item>
        </a-col>

        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
          <a-form-model-item prop="nccTest.res" label="返回结果">
            <a-textarea @keyup.enter.stop v-model="form.nccTest.res" :autoSize="{ minRows: 4 }" />
          </a-form-model-item>
        </a-col>

        <a-col :xs="1" :sm="1">
          <a-button type="primary" icon="check" @click="handleSave" style="margin-bottom: 0">提交</a-button>
        </a-col>
      </a-row>
    </a-form-model>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { httpAction, getAction, postAction } from '@/api/manage'

class formDef {
  nccTest = {
    url: undefined,
    param: undefined,
    res: undefined,
  }
}

export default {
  name: 'NccTestManage',
  mixins: [tableMixin],
  data() {
    return {
      // フォーム
      form: new formDef(),
      // 加载中
      loading: false,
      url: {
        save: '/NccTest/save',
      },
    }
  },
  methods: {
    handleSave() {
      this.$refs.form.validateFieldsAndScroll((ok) => {
        if (ok) {
          if (this.loading) {
            return
          } else {
            this.loading = true
          }

          postAction(this.url.save, this.form.nccTest)
            .then((res) => {
              if (res.success) {
                this.$message.success('提交成功')
                this.form.nccTest.res = XEUtils.toJSONString(res.result.data)
              } else {
                this.form.nccTest.res = undefined
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>
<style scoped></style>
